/**
 * Author: Paul Grejaldo
 * Date: 2018/10/16
 * Time: 5:53 PM
 */
import React, { Component, Fragment } from 'react';
import { __ } from 'wp.i18n';
import PropTypes from 'prop-types';
import Row from './Row';

class Form extends Component {
	constructor( props ) {
		super( props );

		this.inputRef = React.createRef();
	}

	componentDidCatch( error, info ) {
		console.log( error );
		console.log( info );
	}

	handleSubmit = ( e ) => {
		const value = this.inputRef.current.value;
		this.props.onSubmit( value, e );
	};

	handleKeyDown = ( e ) => {
		const value = this.inputRef.current.value;
		this.props.onKeyDown( value, e );
	};

	render() {
		return (
			<Row>
				<div className="col">
					<div className="d-flex justify-content-center mb-2">
						<form className="form-inline">
							<label
								className="sr-only"
								htmlFor="enter-zip-code"
							>{ __( 'Enter your ZIP code' ) }</label>
							<input
								id="enter-zip-code"
								className={ `inputZip` }
								type="text"
								placeholder={ __( 'Enter your ZIP code' ) }
								ref={ this.inputRef }
								defaultValue={ '' }
								onKeyDown={ this.handleKeyDown }
							/>
							<button
								type="button"
								className={ `btn btn-primary ml-2 serviceAreaBtn` }
								onClick={ this.handleSubmit }
							>{ __( 'SEARCH' ) }</button>
						</form>
					</div>
				</div>
			</Row>
		);
	}
}

Form.propTypes = {
	onSubmit  : PropTypes.func,
	onKeyDown : PropTypes.func
};

Form.defaultProps = {};

export default Form;
